import {
  BILLING_MODES,
  DEFAULT_SLIDER_INDEX,
  isPricingBillingModeAvailable,
  parseSliderIndexFromSkuKey,
} from '~/constants/pricingPlans.js'

/** 点击 Buy Now 时写入；支付成功回跳后读取并恢复选中套餐 + 滑条 */
export const CHECKOUT_PLAN_SELECTION_KEY = 'lip_checkout_plan_selection'

const SELECTION_TTL_MS = 7 * 24 * 60 * 60 * 1000

/** @param {Record<string, unknown> | null | undefined} plan */
export function buildCheckoutPlanSelection(plan) {
  if (!plan?.tier || !plan?.billing) return null
  if (!Object.values(BILLING_MODES).includes(plan.billing)) return null
  if (!isPricingBillingModeAvailable(plan.billing)) return null

  /** @type {Record<string, number>} */
  const sliderStatePatch = {}
  if (plan.tier === 'pro' || plan.tier === 'ultra') {
    const rawIndex = plan.sliderIndex ?? plan.slider_index
    if (rawIndex != null && Number.isFinite(Number(rawIndex))) {
      sliderStatePatch[plan.tier] = Number(rawIndex)
    } else {
      sliderStatePatch[plan.tier] = parseSliderIndexFromSkuKey(plan.key ?? plan.skuKey)
    }
  }

  return {
    billing: plan.billing,
    tier: plan.tier,
    skuKey: String(plan.key ?? plan.skuKey ?? ''),
    productId: String(plan.price_code ?? plan.product_id ?? ''),
    sliderStatePatch,
  }
}

export function persistCheckoutPlanSelection(plan) {
  if (!import.meta.client) return
  const selection = buildCheckoutPlanSelection(plan)
  if (!selection) return
  try {
    localStorage.setItem(
      CHECKOUT_PLAN_SELECTION_KEY,
      JSON.stringify({ ...selection, savedAt: Date.now() }),
    )
  } catch {
    /* ignore */
  }
}

export function readCheckoutPlanSelection() {
  if (!import.meta.client) return null
  try {
    const raw = localStorage.getItem(CHECKOUT_PLAN_SELECTION_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    const age = Date.now() - Number(data?.savedAt || 0)
    if (!data?.tier || !data?.billing || age > SELECTION_TTL_MS) {
      localStorage.removeItem(CHECKOUT_PLAN_SELECTION_KEY)
      return null
    }
    return {
      billing: data.billing,
      tier: data.tier,
      skuKey: data.skuKey ?? '',
      productId: data.productId ?? '',
      sliderStatePatch: data.sliderStatePatch ?? {},
    }
  } catch {
    return null
  }
}

export function clearCheckoutPlanSelection() {
  if (!import.meta.client) return
  try {
    localStorage.removeItem(CHECKOUT_PLAN_SELECTION_KEY)
  } catch {
    /* ignore */
  }
}
